// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/admin';
// import router from "../../../router/index";

const state = {
    // Additional state if needed

}

const mutations = {

}

const actions = {
    // Additional actions if needed

    askToChatBot({ commit }, payload) {
        console.log("payload--", payload);
        // return
        // var formData = new FormData();
        // formData.append("question", payload.message);
        const formData = {
            question: payload.question,
            state: payload.state,
            source: payload.source,
        }

        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + apis.ASK_TO_CHATBOT, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("askToChatBot res", res);
                    resolve(res);
                    commit('')
                })
                .catch((err) => {
                    console.log("askToChatBot err", err);
                    reject(err);
                });
        });
    },
    botInitialize({ commit }) {

        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + apis.BOT_INITIALIZE, {}, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("BOT_INITIALIZE res", res);
                    resolve(res.data.data);
                    commit('')
                })
                .catch((err) => {
                    console.log("BOT_INITIALIZE err", err);
                    reject(err);
                });
        });
    },


}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
};